import { useState } from 'react';
import ComicCard from '@/components/feature/ComicCard';
import SectionHeading from '@/components/base/SectionHeading';
import { comics } from '@/mocks/comics';

const TABS = ['推荐', '热门', '最新', '完结'];

export default function ComicRecommend() {
  const [tab, setTab] = useState('推荐');

  const sorted = [...comics];
  if (tab === '热门') {
    sorted.sort((a, b) => b.popularity - a.popularity);
  } else if (tab === '最新') {
    sorted.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
  } else if (tab === '完结') {
    sorted.sort((a, b) => (a.status === '已完结' ? -1 : 1));
  }
  const list = sorted.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8">
      <SectionHeading title="漫画推荐" subtitle="近期热门与主编精选，找到你的下一部心头好" moreTo="/category/comics" />
      <div className="inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-100 p-1">
        {TABS.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => setTab(item)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-label font-500 transition-colors ${
              tab === item ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            {item}
          </button>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-5">
        {list.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}